import { Card, CardContent } from "@/components/ui/card";
import { MessageSquare, Users, TrendingUp, Bot } from "lucide-react";
import {
  formatLargeNumber,
  formatPercent,
  getTrendColor,
  getTrendBg,
} from "./utils";

export const AnalyticsKPICards = ({ data }) => {
  const comparison = data.comparison || {};

  const cards = [
    {
      icon: MessageSquare,
      color: "emerald",
      title: "Mensajes Totales",
      value: formatLargeNumber(data.total_messages),
      delta: comparison.messages_delta_percent,
    },
    {
      icon: Users,
      color: "blue",
      title: "Contactos Unicos",
      value: formatLargeNumber(data.unique_contacts),
      delta: comparison.contacts_delta_percent,
    },
    {
      icon: TrendingUp,
      color: "amber",
      title: "Conversion Chat → Pedido",
      value: `${data.conversion_rate}%`,
      delta: comparison.conversion_delta_percent,
    },
    {
      icon: Bot,
      color: "indigo",
      title: "IA vs Humano",
      value: `${Math.round((data.total_bot_replies / (data.total_bot_replies + data.total_human_replies)) * 100) || 0}%`,
      delta: null,
    },
  ];

  const colorMap = {
    emerald: "text-emerald-600",
    blue: "text-blue-600",
    amber: "text-amber-600",
    indigo: "text-indigo-600",
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card, i) => {
        const Icon = card.icon;
        return (
          <Card key={i} className="bg-card border-border/50">
            <CardContent className="pt-5 text-center">
              <Icon className={`w-6 h-6 ${colorMap[card.color]} mx-auto mb-2`} />
              <p className="text-3xl font-bold">{card.value}</p>
              <p className="text-xs text-muted-foreground mt-1">
                {card.title}
              </p>
              {card.delta !== null && card.delta !== undefined && (
                <p
                  className={`text-xs font-medium mt-2 ${getTrendColor(
                    card.delta
                  )}`}
                >
                  {formatPercent(card.delta)}
                </p>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
